import Box from '@mui/material/Box';
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { AuthHandler } from '@/features/auth';
import {
  loadAndValidatePermissions,
  miniDrawerWidth,
  Sidebar,
} from '@/features/navigation';
import ReportsWebSocketProvider from '@/features/reporting/components/ReportsWebSocketProvider';
import { PlatformProvider } from '@/features/users';

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    await loadAndValidatePermissions(context, location);
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AuthHandler>
      <ReportsWebSocketProvider>
        <PlatformProvider>
          <Box display='flex' position='relative' minHeight='100dvh'>
            <Sidebar />
            <Box
              component='main'
              flexGrow={1}
              width='100%'
              ml={`${miniDrawerWidth.toString()}px`}
            >
              <Outlet />
            </Box>
          </Box>
        </PlatformProvider>
      </ReportsWebSocketProvider>
    </AuthHandler>
  );
}
